module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Message 消息提示",
      "description": "常用于主动操作后的反馈提示。与 Notification 的区别是后者更多用于系统级通知的被动提醒。",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础用法",
      "description": "从顶部出现，3 秒后自动消失。",
      "highlight": _vm.sourcecodeA
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("打开消息提示")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.openVn
    }
  }, [_vm._v("VNode")])], 1), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            接受一个 "), _c('code', [_vm._v("options")]), _vm._v(" 字面量参数，在最简单的情况下，你可以设置 "), _c('code', [_vm._v("message")]), _vm._v(" 字段，用于设置正文内容。\n            默认情况下，经过一段时间后 "), _c('code', [_vm._v("Message")]), _vm._v(" 组件会自动关闭，但是通过设置 "), _c('code', [_vm._v("duration")]), _vm._v("，可以控制关闭的时间间隔，特别的是，如果设置为\n            "), _c('code', [_vm._v("0")]), _vm._v("，则不会自动关闭。\n            注意："), _c('code', [_vm._v("duration")]), _vm._v(" 接收一个 "), _c('code', [_vm._v("Number")]), _vm._v("，单位为毫秒，默认为 "), _c('code', [_vm._v("3000")]), _vm._v("。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "不同状态",
      "description": "用来显示「成功、警告、消息、错误」类的操作反馈。",
      "highlight": _vm.sourcecodeB
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open2
    }
  }, [_vm._v("成功")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open3
    }
  }, [_vm._v("警告")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("消息")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open4
    }
  }, [_vm._v("错误")])], 1), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            当需要自定义更多属性时，"), _c('code', [_vm._v("Message")]), _vm._v(" 也可以接收一个对象为参数。比如，设置 "), _c('code', [_vm._v("type")]), _vm._v(" 字段可以定义不同的状态，默认为 "), _c('code', [_vm._v("info")]), _vm._v("。\n            此时正文内容以 "), _c('code', [_vm._v("message")]), _vm._v(" 的值传入。同时，我们也为 "), _c('code', [_vm._v("Message")]), _vm._v(" 的各种 "), _c('code', [_vm._v("type")]), _vm._v("\n            注册了方法，可以在不传入 "), _c('code', [_vm._v("type")]), _vm._v(" 字段的情况下像 "), _c('code', [_vm._v("open4")]), _vm._v(" 那样直接调用。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "加载中",
      "description": "Loading 状态，可以再操作完成后手动移除。",
      "highlight": _vm.sourcecodeC
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.openLoading
    }
  }, [_vm._v("加载中")])], 1), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            多次触发返回的仍是同一个 "), _c('code', [_vm._v("Message")]), _vm._v(" 实例。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "可关闭",
      "description": "可以添加关闭按钮。",
      "highlight": _vm.sourcecodeD
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open5
    }
  }, [_vm._v("成功")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open6
    }
  }, [_vm._v("警告")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open7
    }
  }, [_vm._v("消息")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open8
    }
  }, [_vm._v("错误")])], 1), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            默认的 "), _c('code', [_vm._v("Message")]), _vm._v(" 是不可以被人工关闭的，如果需要可手动关闭的 "), _c('code', [_vm._v("Message")]), _vm._v("，可以使用 "), _c('code', [_vm._v("showClose")]), _vm._v(" 字段。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "全局方法",
      "show-content": false,
      "code": _vm.sourcecodeF
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            你可以在导入 "), _c('code', [_vm._v("Message")]), _vm._v(" 组件之后， 为 Vue.prototype 添加了全局方法 $message。因此在 vue instance 中可以采用本页面中的方式调用 Message。\n        ")]), _vm._v(" "), _c('templalte', [_c('div', {
    staticClass: "vd-demo__desc"
  }, [_c('ul', [_c('li', [_c('code', [_vm._v("this.$message(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("this.$message.info(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("this.$message.success(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("this.$message.warning(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("this.$message.error(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("this.$message.loading(options)")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "单独引用",
      "show-content": false,
      "code": _vm.sourcecodeE
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            单独引入 "), _c('code', [_vm._v("Message")]), _vm._v("：\n        ")]), _vm._v(" "), [_c('div', {
    staticClass: "vd-demo__desc"
  }, [_vm._v("\n                此时调用方法为 "), _c('code', [_vm._v("Message(options)")]), _vm._v("。我们也为每个 "), _c('code', [_vm._v("type")]), _vm._v(" 定义了各自的方法，如 "), _c('code', [_vm._v("Message.success(options)")]), _vm._v("。 并且可以调用 "), _c('code', [_vm._v("Message.closeAll()")]), _vm._v("\n                手动关闭所有实例。\n                "), _c('ul', [_c('li', [_c('code', [_vm._v("Message(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Message.info(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Message.success(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Message.warning(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Message.error(options)")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("Message.loading(options)")])])])])]], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Options",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("zIndex "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("层级")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("2000")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("message")]), _vm._v(" "), _c('td', [_vm._v("消息文字")]), _vm._v(" "), _c('td', [_vm._v("string / VNode")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("主题")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("success/warning/info/error/loading")]), _vm._v(" "), _c('td', [_vm._v("info")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("iconClass")]), _vm._v(" "), _c('td', [_vm._v("自定义图标的类名，会覆盖 "), _c('code', [_vm._v("type")])]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("customClass")]), _vm._v(" "), _c('td', [_vm._v("自定义类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("duration")]), _vm._v(" "), _c('td', [_vm._v("显示时间, 毫秒。设为 0 则不会自动关闭")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("3000")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("showClose")]), _vm._v(" "), _c('td', [_vm._v("是否显示关闭按钮")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("onClose")]), _vm._v(" "), _c('td', [_vm._v("关闭时的回调函数, 参数为被关闭的 message 实例")]), _vm._v(" "), _c('td', [_vm._v("function")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "方法",
      "show-content": false
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            调用 "), _c('code', [_vm._v("Message")]), _vm._v(" 或 "), _c('code', [_vm._v("this.$message")]), _vm._v(" 会返回当前 "), _c('code', [_vm._v("Message")]), _vm._v(" 的实例。\n            如果需要手动关闭实例，可以调用它的 "), _c('code', [_vm._v("close")]), _vm._v(" 方法。\n        ")]), _vm._v(" "), _c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("方法名")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', [_vm._v("关闭当前的 Message")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "show-content": false,
      "code": _vm.sourcecodeG
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n            全局配置 "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增特性）")])]), _vm._v(" "), _c('template', {
    slot: "description"
  }, [_vm._v("\n            调用 "), _c('code', [_vm._v("Message.config(options) ")]), _vm._v(" 来进行全局配置。\n        ")]), _vm._v(" "), _c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("top")]), _vm._v(" "), _c('td', [_vm._v("提示组件距离顶端的距离，单位像素")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("duration")]), _vm._v(" "), _c('td', [_vm._v("显示时间, 毫秒。设为 0 则不会自动关闭，优先级低于局部配置")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("zIndex")]), _vm._v(" "), _c('td', [_vm._v("层级，优先级低于局部配置")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "show-content": false
    }
  }, [_c('p', [_vm._v("示例使用详情请参考：（"), _c('a', {
    attrs: {
      "href": "https://github.com/savoygu/vue-demonstration"
    }
  }, [_vm._v("https://github.com/savoygu/vue-demonstration")]), _vm._v("）\n        ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5c6603ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5c6603ea","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 10
// module chunks = 0